// extracted by mini-css-extract-plugin
module.exports = {"MenuWithDropdown":"MenuWithDropdown_MenuWithDropdown__q9E2d","Active":"MenuWithDropdown_Active__1Y-UG","DropdownItem":"MenuWithDropdown_DropdownItem__3Co-5"};